module.exports = __webpack_public_path__ + "images/tabs/calendar-off.png";